import { render } from "./HomePage.vue?vue&type=template&id=969aa3fe&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=969aa3fe&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969aa3fe"]])

export default __exports__